<template>
  <v-container grid-list-md>
    <div class="pageTitle">勤怠管理</div>

    <v-expansion-panel v-model="panel" expand style="margin: 10px 0px">
      <v-expansion-panel-content>
        <template v-slot:header>
          <div class="title">表示条件</div>
        </template>
        <v-card>
          <v-card-text>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">年月</v-flex>
              <v-flex md2>
                <v-select :items="years" v-model="year" suffix="年" />
              </v-flex>
              <v-flex md1>
                <v-select :items="months" v-model="month" suffix="月" />
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">チーム</v-flex>
              <v-flex md2 v-for="(team, i) in teams" :key="i">
                <v-checkbox
                  v-model="selectedTeams"
                  :label="team"
                  :value="team"
                  :disabled="CanI('ManageMyTeam')"
                ></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">スタッフ</v-flex>
              <v-flex md8>
                <v-autocomplete
                  v-model="selectedStaffs"
                  :items="staffs"
                  chips
                  item-text="name"
                  item-value="name"
                  multiple
                  :menu-props="{ auto: true, overflowY: true }"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex md2>
                <v-btn @click="clearSelectedStaffs">
                  <v-icon>backspace</v-icon>クリア
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">期間</v-flex>
              <v-flex md1>
                <v-text-field
                  v-model="from_day"
                  suffix="日"
                  type="number"
                  min="1"
                  max="31"
                ></v-text-field>
              </v-flex>
              <v-flex md2 style="text-align: center"> 〜 </v-flex>
              <v-flex md1>
                <v-text-field
                  v-model="to_day"
                  suffix="日"
                  type="number"
                  min="1"
                  max="31"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">その他</v-flex>
              <v-flex md2>
                <v-checkbox v-model="hasHomeWork" label="在宅あり"></v-checkbox>
              </v-flex>
              <v-flex md2>
                <v-checkbox v-model="hasExpence" label="経費あり"></v-checkbox>
              </v-flex>
              <v-flex md2>
                <v-checkbox v-model="hasDailyCommutingAllowance" label="交通費あり"></v-checkbox>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-start row fill-height>
              <v-flex md2 class="search-label subheading">フリーワード *</v-flex>
              <v-flex md4>
                <v-text-field v-model="search"></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-dialog v-model="dialog" persistent max-width="80%">
      <read-timecard
        @closeDialog="dialog = false"
        v-model="selectedTimecard"
        v-if="dialog"
      />
    </v-dialog>
    <v-layout style="height: 500px; width: 100%">
      <div class="table-container scroll-bar">
        <v-data-table
          :headers="headers"
          :items="filteredItems"
          class="elevation-1"
          :search="search"
          :pagination.sync="pagination"
          rows-per-page-text="表示行"
          :rows-per-page-items="rowsPerPageItems"
          style="width: 1500px"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="{ sticky: true, 'column-fixed': header.text == '日 *' }"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr @click="readItem(props.item)">
              <td></td>
              <td class="text-xs-left" :class="dayClass(props.item)">
                {{ props.item.month }}
              </td>
              <td
                class="text-xs-left column-fixed"
                :class="dayClass(props.item)"
              >
                {{ props.item.date }}
              </td>
              <td class="text-xs-left" :class="dayClass(props.item)">
                {{ toDay(props.item.day_number) }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.owner_name }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.holidayType }}
              </td>
              <td class="text-xs-left">{{ getTime(props.item.start) }}</td>
              <td class="text-xs-left">{{ getTime(props.item.end) }}</td>
              <td class="text-xs-left">{{ getNonworking(props.item) }}</td>
              <td class="text-xs-left">{{ getWorking(props.item) }}</td>
              <td class="text-xs-left">{{ getLateNight(props.item) }}</td>
              <td class="text-xs-left">
                {{
                  props.item.is_completed && props.item.total_home_working_hours
                    ? getTime(props.item.total_home_working_hours)
                    : ""
                }}
              </td>
              <td class="text-xs-left text-smaller">
                <summary-data-tooltip
                  :items="props.item.costs"
                  v-if="props.item && props.item.is_completed"
                />
              </td>
              <td class="text-xs-left text-smaller">
                <summary-data-tooltip
                  v-if="props.item && props.item.is_completed"
                  :items="props.item.expenses"
                />
              </td>
              <td class="text-xs-left text-smaller">
                {{ isEdited(props.item) }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ getSummaryOfNote(props.item.note) }}
              </td>
              <td class="text-xs-left text-smaller">
                {{
                  props.item && props.item.daily_commuting_allowance
                    ? toFormattedMoney(props.item.daily_commuting_allowance)
                    : ""
                }}
              </td>
            </tr>
          </template>
          <template slot="pageText" slot-scope="props"
            >{{ props.itemsLength }} 件中 {{ props.pageStart }} -
            {{ props.pageStop }} 件表示</template
          >
        </v-data-table>
      </div>
    </v-layout>
    <v-btn color="green" class="white--text" @click="scrollToTop">
      <v-icon color="white">arrow_upward</v-icon>トップへ戻る
    </v-btn>
    <v-btn
      color="green"
      class="white--text"
      @click="downloadUsersFile"
      v-if="CanI('DowndoadAttendance')"
    >
      <v-icon color="white">cloud_download</v-icon>ダウンロード
    </v-btn>
  </v-container>
</template>

<script>
import db from "@/components/firebaseInit";
import ReadTimecard from "@/components/ManageAttendance/readTimecard.vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { getMoment, unixtimeToFormattedLargeTime } from "@/utils/datetime.js";
import { teamsArray } from "@/master/users.js";
import SummaryDataTooltip from "@/components/Home/summaryDataAndTooltip";
export default {
  components: {
    ReadTimecard,
    SummaryDataTooltip,
  },
  data() {
    return {
      hasHomeWork:false,
      hasExpence:false,
      hasDailyCommutingAllowance:false,
      dbRef: db.collection("timecards"),
      dialog: false,
      year: 2022,
      to_day: 31,
      from_day: 1,
      month: 1,
      dates: [],
      timecards: [],
      items: [],
      years: [2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      teams: teamsArray,
      selectedTeams: [],
      selectedTimecard: {},
      selectedStaffs: [],
      staffs: [],
      panel: [true],
      dayOfWeekStr: ["日", "月", "火", "水", "木", "金", "土"],
      headers: [
        { sortable: false, width: "0%" }, //何故か1日のみテンプレートIDがクラスに入らないので特殊対応
        { text: "月", sortable: false, width: "3%" },
        { text: "日 *", value: "date", sortable: false, width: "3%" },
        { text: "曜日", value: "day", sortable: false, width: "3%" },
        { text: "名前 *", value: "owner_name", sortable: false, width: "10%" },
        { text: "休暇 *", sortable: false, width: "5%", value:"holidayType" },
        { text: "始業", sortable: false, width: "5%" },
        { text: "終業", sortable: false, width: "5%" },
        { text: "差引", sortable: false, width: "5%" },
        { text: "実働", sortable: false, width: "5%" },
        { text: "深夜", sortable: false, width: "5%" },
        { text: "在宅", sortable: false, width: "5%" },
        { text: "原価概要", sortable: false, width: "20%" },
        { text: "経費概要", sortable: false, width: "5%" },
        { text: "修正", sortable: false, width: "10%" },
        { text: "備考", sortable: false, width: "20%" },
        { text: "交通費", sortable: false, width: "7%" },
      ],
      pagination: {
        rowsPerPage: 100,
      },
      rowsPerPageItems: [50, 100, 200],
      search: "",
    };
  },
  created() {
    const today = getMoment()();
    this.month = today.month() + 1;
    this.year = today.year();
    this.reloadItems();
  },
  mounted() {
    this.fixHeaders();
    this.reloadStaffs();
  },
  computed: {
    month_id() {
      return String(this.year) + "-" + ("0" + this.month).slice(-2);
    },
    filteredItems() {
      if (this.CanI("ManageMyTeam")) {
        this.selectedTeams = [this.profile.team_name];
      }
      return this.items.filter((item) => {
        return (
          this.selectedTeams.includes(item.owner_team) &&
          (this.selectedStaffs.length == 0 ||
            this.selectedStaffs.includes(item.owner_name)) &&
          (item.date >= this.from_day && item.date <= this.to_day) &&
          (! this.hasHomeWork || item.total_home_working_hours > 0) &&
          (! this.hasExpence || item.expenses && item.expenses.length > 0) &&
          (! this.hasDailyCommutingAllowance || item.daily_commuting_allowance > 0)
        );
      }, this);
    },
    ...mapGetters("auth", ["CanI", "isLoggedIn", "user", "profile"]),
    ...mapState("auth", ["user_type", "work_type", "team_name", "authorities"]),
  },
  watch: {
    month() {
      this.reloadItems();
    },
  },
  methods: {
    scrollToTop() {
      document.querySelector(".v-datatable tbody tr").scrollIntoView(false);
    },
    clearSelectedStaffs() {
      this.selectedStaffs = [];
    },
    async reloadItems() {
      this.changeLoadingState(true);
      const items = await this.dbRef
        .where("month_id", "==", this.month_id)
        .orderBy("date", "desc")
        .get();
      this.items = [];
      items.forEach((doc) => {
        const item = doc.data();
        this.items.push({ ...item, id: doc.id });
      });
      this.changeLoadingState(false);
    },
    async reloadStaffs() {
      this.changeLoadingState(true);
      this.staffs = [];
      try {
        const staffs = await db.collection("users").get();
        staffs.forEach((doc) => {
          this.staffs.push({ ...doc.data(), id: doc.id });
        });
      } finally {
        this.changeLoadingState(false);
      }
    },
    prvMonth() {
      this.month = this.month - 1;
    },
    nextMonth() {
      this.month = this.month + 1;
    },
    dayClass(d) {
      if (d.day_number == 0 || d.is_holiday) {
        return { holiday: true };
      } else if (d.day_number == 6) {
        return { saturday: true };
      }
    },
    toDay(dayNumber) {
      return this.dayOfWeekStr[dayNumber];
    },
    getWorking(timecard) {
      return this.getTime(
        timecard.end -
          timecard.start -
          timecard.lunch -
          timecard.break -
          (timecard.total_nonworking_hours
            ? timecard.total_nonworking_hours
            : 0)
      );
    },
    getNonworking(timecard) {
      return this.getTime(
        timecard.lunch +
          timecard.break +
          (timecard.total_nonworking_hours
            ? timecard.total_nonworking_hours
            : 0)
      );
    },
    getLateNight(timecard) {
      const lateNightTime = 22 * 3600;
      return this.getTime(
        timecard.end - lateNightTime <= 0 ? 0 : timecard.end - lateNightTime
      );
    },
    getTime(unixtime) {
      return unixtimeToFormattedLargeTime(unixtime);
    },
    isEdited(timecard) {
      return timecard.isEditWorktime && timecard.isEditWorktime ? "修正" : "";
    },
    readItem(timecard) {
      this.selectedTimecard = JSON.parse(JSON.stringify(timecard));
      this.dialog = true;
    },
    getSummaryOfNote(note) {
      return note && note.length >= 25 ? note.slice(0, 25) + "..." : note;
    },
    getSummaryOfExpence(expenses) {
      let summary = "";
      expenses.forEach((expense) => {
        summary =
          summary +
          expense.client_name.replace("株式会社", "").replace("有限会社", "") +
          ": ¥" +
          expense.price +
          ", ";
      });
      summary = summary.slice(0, -2); //最後の", "を削除
      return summary.length >= 15 ? summary.slice(0, 15) + "..." : summary;
    },
    endtimeIsValid(tc) {
      return tc.end - tc.start - tc.lunch - tc.break > 0;
    },
    toFormattedMoney(m) {
      const money = Number(m);
      return Number.isInteger(money)
        ? "¥ " + money.toLocaleString("ja")
        : "Invalid Money :" + money;
    },
    downloadUsersFile() {
      var FileSaver = require("file-saver");
      let fileName = "attendance-" + this.month_id + ".json";
      let strJson = JSON.stringify(this.items, null, 4);
      // console.log(JSON.stringify(this.items));
      // let fileToSave = new Blob([JSON.stringify(this.itmes, null, 4)], {
      //   type: "application/json",
      //   name: fileName,
      // });
      let fileToSave = new Blob([strJson], {
        type: "application/json",
        name: fileName,
      });
      FileSaver.saveAs(fileToSave, fileName);
    },
    fixHeaders() {
      var elms = document.getElementsByClassName("v-table__overflow");
      elms[0].style.overflow = "visible";
    },
    ...mapActions("app", ["changeLoadingState"]),
  },
};
</script>

<style lang="css" scoped>
div.pageTitle {
  font-size: 20px;
  color: #ff5722;
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
div.yearMonth {
  display: inline-block;
  font-size: 20px;
  /* color: #ddd; */
  font-family: YuGothicM, Roboto, sans-serif;
  font-weight: bold;
  margin: 10px;
}
td.holiday {
  color: #f44336;
}
td.saturday {
  color: #2196f3;
}
td.text-smaller {
  font-size: 0.8em;
}
.search-label {
}
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 50, 0.5);
  border-radius: 10px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.3);
}
.v-datatable th.sticky {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;
}
.v-datatable td.column-fixed {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  left: 0;
}
.v-datatable th.column-fixed {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 2;
  left: 0;
}

.scroll-bar {
  overflow: auto;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background: gray;
}
.v-icon {
  margin-right: 0.3em;
}
</style>
